
import React, { useState } from "react";
import FillResults from "./FillResults";
import { BASE_URL } from "../apiConfig";

export default function SearchControl() {
    const [fillData, setFillData] = useState(false);
    const [singleResult, setSingleResult] = useState(false);

    const searchTireSizes = () => {
        const searchVal = document.getElementById('searchBox').value;

        const constructedObject = {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            method: "POST",
            body: JSON.stringify({"query" : searchVal}),
        };

        fetch(`${BASE_URL}/searchTireFill`, constructedObject).then(searchResults => {
            let isSingle = false;
            searchResults.json().then(results => {
                const matchedKey = Object.keys(results.tireFillData).find(key => key.toLowerCase() === searchVal.toLowerCase());

                if(matchedKey && matchedKey.length) {
                    isSingle = true;
                    results.tireFillData = {[matchedKey] : results.tireFillData[matchedKey]};
                }
                setSingleResult(isSingle)
                setFillData(results.tireFillData);
            });
        });
    }

    return (
        <div className="search-container">
            <div className="form-row justify-content-center">
                <div className="form-group col">
                    <input id="searchBox" type="text" placeholder="for example: 15-19.5" className="form-control" />
                </div>
                <div className="form-group">
                    <button onClick={searchTireSizes} className="btn btn-rg-purple mb-0"> Search </button>
                </div>
            </div>
            
            {fillData ? (
                <FillResults fillData={fillData} singleResult={singleResult} /> 
            ) : (
                <div></div>
            )}
        </div>
    );
}